import { toast } from "react-toastify";
import ApiClient from "../api-client/apiClient";
import { handleIsLoading, handleListing } from "../store/general";
import { getAccessToken } from "../auth";
const apiUrl = process.env.REACT_APP_API_URL;
const version = process.env.REACT_APP_API_VERSION;

export const getOrgLeaderOrganizationAction =
  (organizationId: any, callback: (response: any) => void) =>
  async (dispatch: any) => {
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/leader/organization/${organizationId}`,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

// --------------------------------------------Data Element asign-----------------------------

/**
 * Create a new category
 * @param {any} data - User details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const assignDataElementsForm = (data: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    dispatch(handleIsLoading(true));
    dispatch(handleListing(true));
    try {
      const response: any = await ApiClient.post(
        `${apiUrl}${version}/leader/data-element/assignment/user`,
        data
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(
          response?.message || "Data element assigned successfully"
        );
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      // Handle API errors and display appropriate error messages
      toast.error(error?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * Fetch list of selected data elements
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const selectedDataElementsList =
  (data: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    const { organizationId, userId } = data;
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/leader/data-element/user/${organizationId}/${userId}`,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

/**
 * Fetch list of budgets
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const dataElementListAction =
  (data: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    const { id, ...params } = data;
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/leader/assigned/data-elements/${id}`,
        params.params,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

//----------------------------------------Data submission--------------------------------------------

/**
 * Fetch list of  data submission
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const dashboardDataSubmissionList =
  (data: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/user/data-submission`,
        data,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };
